import { RootState } from "../reducers"

export const getEpcsInitialize = (state: RootState) => state.epcsInitialize;
export const getEpcsStatus = (state: RootState) => state.epcsStatus;
export const getEpcsTokenRefGuid = (state: RootState) => state?.epcsStatus?.tokenRefGuid;